import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiWifiOff,FiWifi,FiRefreshCw}=FiIcons;

const OfflineIndicator=()=> {
  const [isOffline,setIsOffline]=useState(!navigator.onLine);
  const [showOfflineBanner,setShowOfflineBanner]=useState(false);

  useEffect(()=> {
    const handleOnline=()=> {
      setIsOffline(false);
      setTimeout(()=> setShowOfflineBanner(false),3000);
    };

    const handleOffline=()=> {
      setIsOffline(true);
      setShowOfflineBanner(true);
    };

    window.addEventListener('online',handleOnline);
    window.addEventListener('offline',handleOffline);

    // Mostrar banner si está offline al cargar
    if (isOffline) {
      setShowOfflineBanner(true);
    }

    return ()=> {
      window.removeEventListener('online',handleOnline);
      window.removeEventListener('offline',handleOffline);
    };
  },[isOffline]);

  const handleRefresh=()=> {
    window.location.reload();
  };

  return (
    <AnimatePresence>
      {showOfflineBanner && (
        <motion.div
          initial={{y: -100,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          exit={{y: -100,opacity: 0}}
          className={`fixed top-0 left-0 right-0 z-50 ${
            isOffline ? 'bg-orange-500' : 'bg-green-500'
          } text-white px-4 py-3 shadow-lg`}
        >
          <div className="flex items-center justify-between max-w-6xl mx-auto">
            <div className="flex items-center space-x-3">
              <SafeIcon icon={isOffline ? FiWifiOff : FiWifi} className="text-xl" />
              <div>
                <p className="font-medium text-sm">
                  {isOffline ? 'Sin conexión a Internet' : 'Conexión restaurada'}
                </p>
                <p className="text-xs opacity-90">
                  {isOffline 
                    ? 'La aplicación funciona en modo offline. Algunas funciones pueden estar limitadas.'
                    : 'Todos los servicios están disponibles.'
                  }
                </p>
              </div>
            </div>
            
            {isOffline && (
              <motion.button
                whileTap={{scale: 0.95}}
                onClick={handleRefresh}
                className="flex items-center space-x-2 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-lg transition-colors"
              >
                <SafeIcon icon={FiRefreshCw} className="text-sm" />
                <span className="text-sm font-medium">Reintentar</span>
              </motion.button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineIndicator;